"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetClassList = resetClassList;
exports.canAnimate = canAnimate;
/* eslint-disable no-console */

function logError() {
  if (process.env.NODE_ENV !== "production") {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function resetClassList(node, classNames) {
  if (node) {
    Object.keys(classNames).forEach(function (key) {
      node.classList.remove(classNames[key]);
    });
  }
}

function canAnimate(shouldLogError) {
  var raf = !!(window && window.requestAnimationFrame);
  var classList = !!(document && document.body && document.body.classList);

  var errorMessage = function errorMessage(featureName) {
    return "TinyTransition: Your browser doesn't support " + featureName + ". Consider adding a polyfill.";
  };

  if (shouldLogError && !raf) {
    logError(errorMessage("requestAnimationFrame"));
  }

  if (shouldLogError && !classList) {
    logError(errorMessage("element.classList"));
  }

  return raf && classList;
}